import { Group, Text, ActionIcon, Container, Card, Menu, TextInput, Button, Modal } from '@mantine/core';
import { IconHelp, IconClockHour4, IconSettings, IconX, IconDeviceDesktop, IconDeviceTablet, IconDeviceMobile, IconTrendingDown, IconDownload } from '@tabler/icons-react';
import { snapdom } from '@zumer/snapdom';
import { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Helmet } from 'react-helmet';
import { useDocumentTitle } from '@mantine/hooks';
import { notifications } from '@mantine/notifications';
import { modals } from '@mantine/modals';
import { useNavigate, Link, useParams } from 'react-router-dom';
import { HeaderMenu } from "../../components/HeaderMenu/HeaderMenu";
import { SelectTimePicker, SelectTooltip, useColorScheme } from "../../components/GeneralComponent/GeneralComponent";
import { visiUserId, visiUserToken } from '../../GeneralFunction';
import { AssetsUrl } from './AssetsUrl';
import InsightsApi from "../../api/InsightsApi";
import './HeatmapView.css';

const loadResource = (tag, attributes) => {
  return new Promise((resolve, reject) => {
    const element = document.createElement(tag);
    Object.keys(attributes).forEach(key => element.setAttribute(key, attributes[key]));
    element.onload = resolve;
    element.onerror = reject;
    document.head.appendChild(element);
  });
};

export function ScrollMapRecordingView() {
  useDocumentTitle("Visiopt - Insights");

  const navigate = useNavigate();
  const { scrollmap_id } = useParams();
  const [selectedScrollmapId] = useState(scrollmap_id);
  const [selectedScrollmapName, setSelectedScrollmapName] = useState('');
  const [scrollmapPauseStatus, setScrollmapPauseStatus] = useState('');
  const [testAssetsUrl, setTestAssetsUrl] = useState('');
  const [deviceType, setDeviceType] = useState('0');
  const [scrollmapStartDate, setScrollmapStartDate] = useState('');
  const [scrollmapEndDate, setScrollmapEndDate] = useState('');
  const [scrollmapRequestUrl, setScrollmapRequestUrl] = useState('');
  const [scrollmapCreateDate, setScrollmapCreateDate] = useState('');
  const [scrollmapDetails, setScrollmapDetails] = useState(false);
  const [isAssetsUrlModalOpen, setIsAssetsUrlModalOpen] = useState(false);
  const [assetsUrlValue, setAssetsUrlValue] = useState('');
  const [iframeContent, setIframeContent] = useState('');
  const [loadResourceLoaded, setLoadResourceLoaded] = useState(0);
  const [pageId, setPageId] = useState('');
  const [pageUrl, setPageUrl] = useState('');
  const [frontEndFramework, setFrontEndFramework] = useState('');
  const [PrerenderCodeStatus, setPrerenderCodeStatus] = useState('');
  const [customHostName, setCustomHostName] = useState('');
  const [websiteUrl, setWebsiteUrl] = useState('');
  let memberId = visiUserId() ? visiUserId() : '';
  const token = visiUserToken() ? visiUserToken() : '';
  const recordingIconRef = useRef(null);
  const [showHelpModal, setShowHelpModal] = useState(false);
  const [helpTargetId, setHelpTargetId] = useState(0);
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });
  const [createdDate, setCreatedDate] = useState('');
  const colorTheme = useColorScheme();

  const [scrollStats, setScrollStats] = useState<any>(null);
  const [dropoff, setDropoff] = useState<any[]>([]);
  const [dropoffOpen, setDropoffOpen] = useState(false);
  const [exporting, setExporting] = useState(false);

  const [selectedMemberWebsite, setSelectedMemberWebsite] = useState('');
  const [selectedTimePicker, setSelectedTimePicker] = useState<number>();
  const [selectedTimePickerToDate, setSelectedTimePickerToDate] = useState('');
  const [selectedTimePickerFromDate, setSelectedTimePickerFromDate] = useState('');

  useEffect(() => {
    const loadResources = async () => {
      try {
        const frontendPublicUrl = process.env.REACT_APP_FRONTEND_PUBLIC_URL;
        await loadResource('script', { src: frontendPublicUrl+'js/jquery.min.js' });
        setLoadResourceLoaded(1);
      } catch (error) {
        console.error('Error loading resource:', error);
      }
    };
    if(pageId !== ""){
      loadResources();
    }
    
  }, [pageId]);

  // Summary numbers and the 20 drop-off bands are computed in the scrollmap iframe
  // (same-origin srcDoc) and posted up here so the report can show them above the map.
  useEffect(() => {
    const onScrollStats = (event: MessageEvent) => {
      const data = event?.data;
      if (data && data.type === 'visi_scroll_stats') {
        setScrollStats(data);
        setDropoff(Array.isArray(data.dropoff) ? data.dropoff : []);
      }
    };
    window.addEventListener('message', onScrollStats);
    return () => window.removeEventListener('message', onScrollStats);
  }, []);

  const handleButtonClickTest = async () => {
    handleShowHideLoader(true);
    let params = {
      page_url : scrollmapRequestUrl,
      page_id : pageId,
      front_end_framework : frontEndFramework,
      prerende_code_status : PrerenderCodeStatus,
      custom_hostname : customHostName,
      member_id: memberId,
      website_url : websiteUrl,
      test_assets_url: testAssetsUrl,
      pause_status: scrollmapPauseStatus,
      site_id: selectedMemberWebsite,
      scrollmap_id: selectedScrollmapId,
      device_type: deviceType,
      selectedTime: selectedTimePicker,
      start_date: scrollmapStartDate,
      end_date: scrollmapEndDate,
      visi_token: token,
    };
    let paramsJSON = JSON.stringify(params);
    let paramsJSONEncoded = btoa(paramsJSON);
  try {
    const response = await axios.post(
      process.env.REACT_APP_BACKEND_API_PATH+"scrollmap-data.php",
      { paramsJSONEncoded },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    setIframeContent(response.data);
    handleShowHideLoader(false);
  } catch (error) {
    handleShowHideLoader(false);
    console.error('Error:', error);
  }
  };

  const handleRefreshStats = () => {
    setScrollStats(null);
    setDropoff([]);
    handleButtonClickTest();
  };

  const handleHeaderMenuComponentChange = (Value:any) => {
    setSelectedMemberWebsite(Value);
  };

  const handleselectedTimePickerComponentChange = (Value:any) => {
    setSelectedTimePicker(Value);
  };

  const handleselectedTimePickerToDateChange = (Value:any) => {
    setSelectedTimePickerToDate(Value);
  };

  const handleselectedTimePickerFromDateChange = (Value:any) => {
    setSelectedTimePickerFromDate(Value);
  };

  /* The device frame is a function of deviceType, applied through the iframe's className
     below. It used to be added by a jQuery helper injected via react-helmet, which meant a
     click landing before jquery.min.js finished loading switched the DATA to mobile but left
     the frame at full desktop width — with nothing that ever re-applied it. */
  const deviceFrameClass = deviceType === '1'
    ? 'active_visi_mobile'
    : deviceType === '2'
      ? 'active_visi_tablet'
      : '';

  const handleMobileView = () => setDeviceType('1');

  const handlePCView = () => setDeviceType('0');

  const handleTabletView = () => setDeviceType('2');

  const fetchScrollmapDetails = () => {
    const dataObject = {
      scrollmap_id: selectedScrollmapId,
      system_website_id: selectedMemberWebsite,
      filter: 1,
      time: selectedTimePicker
    } as any;
    if(selectedTimePicker === -2){
      const [fromMonth, fromDay, fromYear] = selectedTimePickerFromDate.split("-").map(num => parseInt(num, 10));
      const [endMonth, endDay, endYear] = selectedTimePickerToDate.split("-").map(num => parseInt(num, 10));
      const fromDate = `${fromMonth}/${fromDay}/${fromYear}`;
      const toDate = `${endMonth}/${endDay}/${endYear}`;
      dataObject.filter = 2;
      dataObject.from = fromDate;
      dataObject.to = toDate;
    }
    handleShowHideLoader(true);
    InsightsApi.getscrollmapdetails(dataObject)
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            navigate("/logout");
            handleShowHideLoader(false);
          }
        }
      })
      .then(data => {
        if(data.status === 1){
          setSelectedScrollmapName(data.data.scrollmap_name);
          setPageUrl(data.data.page_url);
          setWebsiteUrl(data.data.website_url);
          setPageId(data.data.page_id);
          setFrontEndFramework(data.data.front_end_framework);
          setPrerenderCodeStatus(data.data.prerender_code_status);
          setCustomHostName(data.data.custom_hostname);
          setScrollmapPauseStatus(data.data.pause_status);
          setTestAssetsUrl(data.data.test_assets_url);
          setScrollmapStartDate(data.data.start_date);
          setScrollmapEndDate(data.data.end_date);
          setScrollmapRequestUrl(data.data.request_url);
          setScrollmapCreateDate(data.data.create_time);
          setCreatedDate(data.data.scrollmap_created_date);
          let decodedUrl = atob(data.data.test_assets_url);
          setAssetsUrlValue(decodedUrl);
          setScrollmapDetails(true);
          handleShowHideLoader(false);
        }else{
          handleShowHideLoader(false);
          notifications.show({
            color: 'red',
            icon: <IconX size="1.1rem" />,
            title: 'Error',
            message: data.message,
          });
        }
      })
      .catch(error => {
        console.error("API Error:", error);
        handleShowHideLoader(false);
      });
  };

  const handleAssetsUrlModalOpen = () => {
    setIsAssetsUrlModalOpen(true);
  };

  const handleAssetsUrlModalClose = () => {
    setIsAssetsUrlModalOpen(false);
  };

  const handleResetStatClick = () => modals.openConfirmModal({
    title: 'Please confirm your action',
    children: (
      <Text size="sm">
        Are you sure you want to reset this report? You will lose any current report data.
      </Text>
    ),
    labels: { confirm: 'Confirm', cancel: 'Cancel' },
    onCancel: () => {console.log('Cancel')},
    onConfirm: () => {handleResetData()},
  });

  const handleResetData = () => {
    InsightsApi.resetscrollmapdata({
      scrollmap_id: selectedScrollmapId
    })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          if (response.status === 401 || response.status === 400) {
            navigate("/logout");
          }
        }
      })
      .then(data => {
        if(data.status === 1){
          fetchScrollmapDetails();
        }else{
          notifications.show({
            color: 'red',
            icon: <IconX size="1.1rem" />,
            title: 'Error',
            message: data.message,
          });
        }
      })
      .catch(error => {
        console.error("API Error:", error);
      });
  };

  const getStartDate = () => {
    const [year, month, day] = createdDate.split('-');
    return `${year}-${month}-${day}`;
  };

  const getSelectedFromDate = () => {
    if(selectedTimePickerFromDate){
      const [month, day, year] = selectedTimePickerFromDate.split('-');
      return `${year}-${month}-${day}`;
    }else{
      const [year, month, day] = createdDate.split('-');
      return `${year}-${month}-${day}`;
    }
  };

  const getSelectedToDate = () => {
    if(selectedTimePickerToDate){
      const [month, day, year] = selectedTimePickerToDate.split('-');
      return `${year}-${month}-${day}`;
    }else{
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }
  };

  const handleBackToInsightsClick = () => {
    navigate("/scroll-maps");
  };

  useEffect(() => {
    if(selectedScrollmapId !== '' && selectedMemberWebsite !== '' && deviceType && selectedTimePicker){
      fetchScrollmapDetails();
    }
  }, [selectedScrollmapId, selectedMemberWebsite, deviceType, selectedTimePicker]);



  useEffect(() => {
    if(scrollmapDetails) {
      handleButtonClickTest();
      setScrollmapDetails(false);
    }
  }, [scrollmapDetails]);

  const handleHelpClick = (id:any) => {
    setShowHelpModal(true);
    setHelpTargetId(id);
    if (recordingIconRef.current) {
      const { top, left, width } = recordingIconRef.current.getBoundingClientRect();
      const scrollOffset = window.scrollY;
      setTooltipPosition({
        top: top + scrollOffset,
        left: left + width + 10, 
      });
    }
  };

  // Same heat ramp the map paints with, so the burned-in legend matches the image.
  const LEGEND_STOPS: Array<[number, string]> = [
    [0.00, '#00005a'], [0.15, '#0000ff'], [0.35, '#008000'],
    [0.55, '#f5e628'], [0.75, '#ffa500'], [1.00, '#ff0000'],
  ];

  const deviceLabel = deviceType === '1' ? 'Mobile' : deviceType === '2' ? 'Tablet' : 'Desktop';

  // The iframe owns the real page height, so the report asks it to scroll rather than trying
  // to compute a pixel offset up here.
  const goToDepth = (percent: number, caption: string) => {
    const iframe = document.getElementById('vis') as HTMLIFrameElement | null;
    if (!iframe || !iframe.contentWindow) { return; }
    iframe.contentWindow.postMessage({ type: 'visi_scroll_goto', percent, caption }, '*');
  };

  // A handful of visitors out of thousands rounds to 0%, which reads as "nobody" while
  // the Deepest reached figure beside it says someone got there. Say "under 1%" instead,
  // with the count.
  const bottomLabel = () => {
    const pct = scrollStats?.reachedBottomPercent;
    const people = Number(scrollStats?.reachedBottomVisitors ?? 0);
    if (pct === null || pct === undefined) { return ''; }
    if (pct === 0 && people > 0) { return `under 1% of visitors (${people.toLocaleString()})`; }
    return `${pct}% of visitors`;
  };

  // Shared look for the clickable numbers above the map.
  // The drawn zones, biggest loss first. The map marks them on the ruler, but the ruler only
  // ever shows the slice beside your viewport - so the header answers "where are my
  // drop-offs" without scrolling the whole page to find them.
  const dropoffZones = dropoff
    .filter((band: any) => band.zone)
    .sort((a: any, b: any) => b.lost - a.lost);

  // The map is sized once, from the height of the header above it. When the header grows -
  // the stats arrive after load, and on a narrower window they wrap onto a second row - the
  // map keeps its old height, overflows, and the page picks up a second scrollbar. Nudging
  // the resize handler once the stats have landed re-measures it.
  useEffect(() => {
    if (!scrollStats) { return; }
    window.dispatchEvent(new Event('resize'));
  }, [scrollStats, dropoff, deviceType]);

  // visiopt-visual.css, loaded for the preview, paints the body light grey and has no dark
  // version. Around the report card that showed as a light frame in the dark theme. Match the
  // theme while this page is open and put the old value back on the way out, so the other
  // screens that share that stylesheet are untouched.
  useEffect(() => {
    if (colorTheme === 'light') { return; }
    const previous = document.body.style.background;
    document.body.style.background = '#1A1B1E';
    return () => { document.body.style.background = previous; };
  }, [colorTheme]);

  const statButton = {
    background: 'none', border: 0, padding: 0, font: 'inherit', cursor: 'pointer',
    color: 'inherit', borderBottom: '1px dashed currentColor',
  } as React.CSSProperties;

  // The context band above the captured page: a map screenshot with no URL, range or visitor
  // count gets misquoted weeks later, so those travel inside the image. Laid out and measured
  // BEFORE the canvas is sized, because a phone-frame capture is only ~420px wide and a fixed
  // layout truncated every line.
  const buildExportHeader = (ctx: CanvasRenderingContext2D, cssWidth: number) => {
    const pad = 20;
    const maxText = Math.max(120, cssWidth - pad * 2);
    const small = cssWidth < 620;
    const lines: Array<{ text: string; font: string; color: string; lh: number }> = [];

    const clip = (text: string) => {
      if (ctx.measureText(text).width <= maxText) { return text; }
      let out = text;
      while (out.length > 1 && ctx.measureText(out + '…').width > maxText) { out = out.slice(0, -1); }
      return out + '…';
    };
    const push = (text: string, font: string, color: string, lh: number) => {
      ctx.font = font;
      let cur = '';
      String(text).split(' ').forEach((word) => {
        const test = cur ? cur + ' ' + word : word;
        if (ctx.measureText(test).width <= maxText) { cur = test; return; }
        if (cur) { lines.push({ text: cur, font, color, lh }); }
        // A long URL has no spaces to break on, so clip that one word instead.
        cur = ctx.measureText(word).width > maxText ? clip(word) : word;
      });
      if (cur) { lines.push({ text: cur, font, color, lh }); }
    };

    const range = scrollStats?.filterStartDate && scrollStats?.filterEndDate
      ? `${scrollStats.filterStartDate} – ${scrollStats.filterEndDate}`
      : 'All time';
    const body = `400 ${small ? 11 : 13}px Arial, Helvetica, sans-serif`;

    push(selectedScrollmapName || 'Scroll map', `700 ${small ? 16 : 20}px Arial, Helvetica, sans-serif`, '#ffffff', small ? 22 : 28);
    push(pageUrl || '', body, '#c7d2de', small ? 16 : 19);
    push(`${range}  ·  ${deviceLabel}  ·  Exported ${new Date().toLocaleString()}`, body, '#c7d2de', small ? 16 : 19);
    // Every percentage carries its unit here too - the export is read out of context weeks later.
    const never = (scrollStats?.neverScrolledPercent === null || scrollStats?.neverScrolledPercent === undefined)
      ? 'Never scrolled: not available yet'
      : `Never scrolled ${scrollStats.neverScrolledPercent}% of visitors`;
    const avgTxt = (scrollStats?.avgScrollDepth === null || scrollStats?.avgScrollDepth === undefined)
      ? 'nobody scrolled' : `${scrollStats.avgScrollDepth}% down the page`;
    const bottomTxt = (scrollStats?.reachedBottomPercent === null || scrollStats?.reachedBottomPercent === undefined)
      ? 'reached bottom: n/a' : `${bottomLabel()} reached the bottom`;
    const depthTxt = (scrollStats?.deepestPercent === null || scrollStats?.deepestPercent === undefined)
      ? '' : `  ·  Deepest reached ${scrollStats.deepestPercent}% down the page`;
    const heightTxt = scrollStats?.pageHeightPx
      ? `  ·  Page height ${Number(scrollStats.pageHeightPx).toLocaleString()}px` : '';
    push(
      `${Number(scrollStats?.totalSessions ?? 0).toLocaleString()} visitors  ·  Avg scroll depth ${avgTxt}  ·  ${bottomTxt}  ·  ${never}${heightTxt}${depthTxt}`,
      `700 ${small ? 12 : 15}px Arial, Helvetica, sans-serif`, '#ffffff', small ? 18 : 22
    );
    if (scrollStats?.lowSample) {
      push('Fewer than 100 visitors — indicative only', `700 ${small ? 11 : 13}px Arial, Helvetica, sans-serif`, '#f2c744', small ? 16 : 19);
    }

    const textHeight = lines.reduce((sum, line) => sum + line.lh, 0);
    return { lines, pad, maxText, height: pad + textHeight + 46 + pad };
  };

  // The legend sits under the text rather than beside it, so it can never collide with a long
  // title or get squeezed off a narrow capture.
  const drawExportHeader = (ctx: CanvasRenderingContext2D, block: any, cssWidth: number, scale: number) => {
    ctx.save();
    ctx.scale(scale, scale);
    ctx.fillStyle = '#1f2b3a';
    ctx.fillRect(0, 0, cssWidth + 2, block.height + 1);

    let y = block.pad;
    block.lines.forEach((line: any) => {
      y += line.lh;
      ctx.fillStyle = line.color;
      ctx.font = line.font;
      ctx.fillText(line.text, block.pad, y - 5);
    });

    const legendWidth = Math.min(260, block.maxText);
    const lx = block.pad;
    const ly = y + 18;
    ctx.font = '400 11px Arial, Helvetica, sans-serif';
    ctx.fillStyle = '#c7d2de';
    let label = 'colour = % of visitors who reached that depth';
    while (label.length > 1 && ctx.measureText(label).width > block.maxText) { label = label.slice(0, -1); }
    ctx.fillText(label, lx, ly - 5);

    const grad = ctx.createLinearGradient(lx, 0, lx + legendWidth, 0);
    LEGEND_STOPS.forEach(([at, color]) => grad.addColorStop(at, color));
    ctx.fillStyle = grad;
    ctx.fillRect(lx, ly, legendWidth, 10);

    ctx.fillStyle = '#c7d2de';
    ctx.fillText('few', lx, ly + 23);
    const right = 'nearly all';
    ctx.fillText(right, lx + legendWidth - ctx.measureText(right).width, ly + 23);
    ctx.restore();
  };


  // Width of the ruler column drawn beside the page in the export, in CSS px.
  const EXPORT_RULER_W = 96;

  // The on-screen ruler is position:fixed, so capturing it would burn one floating fragment
  // into the middle of the image. It is hidden for the capture and redrawn here instead, as a
  // full-height scale beside the page — same marks, same meaning, correct for a static image.
  const drawExportRuler = (ctx: CanvasRenderingContext2D, x: number, y: number, h: number, scale: number) => {
    const w = EXPORT_RULER_W;
    ctx.save();
    ctx.scale(scale, scale);
    ctx.fillStyle = '#111821';
    ctx.fillRect(x, y, w, h);

    const headH = 22;
    const legendH = 74;
    const top = y + headH;
    const span = h - headH - legendH;

    ctx.fillStyle = '#ffffff';
    ctx.font = '700 10px Arial, Helvetica, sans-serif';
    ctx.fillText('Page depth', x + 8, y + 15);

    // 10% steps
    ctx.font = '600 9px Arial, Helvetica, sans-serif';
    for (let p = 0; p <= 100; p += 10) {
      const ty = top + (span * p) / 100;
      ctx.fillStyle = 'rgba(255,255,255,0.28)';
      ctx.fillRect(x, ty, w, 1);
      ctx.fillStyle = 'rgba(255,255,255,0.72)';
      ctx.fillText(p + '%', x + 5, ty + 11);
    }

    // reach milestones, at their true page position
    (scrollStats?.milestones ?? []).forEach((m: any) => {
      const ty = top + (span * Math.max(0, Math.min(100, m.atPercent))) / 100;
      ctx.fillStyle = m.threshold === 50 ? '#ff8a00' : '#ffb020';
      ctx.fillRect(x, ty, w - 14, m.threshold === 50 ? 3 : 2);
    });

    // drop-off bands, on the right edge like the live ruler
    // The same zones the map draws, with the ordinal only where the margin earned one.
    dropoff.filter((b: any) => b.zone)
      .sort((a: any, b: any) => b.lost - a.lost)
      .forEach((b: any) => {
        const ty = top + (span * b.fromPercent) / 100;
        const th = Math.max(3, (span * (b.toPercent - b.fromPercent)) / 100);
        ctx.fillStyle = '#d62d2d';
        ctx.fillRect(x + w - 8, ty, 8, th);
        ctx.fillStyle = '#ff8f8f';
        ctx.font = '700 9px Arial, Helvetica, sans-serif';
        if (b.rank) { ctx.fillText('#' + b.rank, x + w - 26, ty + 9); }
      });

    // legend
    const ly = y + h - legendH + 8;
    const rows: Array<[string, string]> = [
      ['rgba(255,255,255,0.35)', '10% steps'],
      ['#ffb020', 'reach milestone'],
      ['#d62d2d', 'drop-off band'],
    ];
    ctx.font = '600 9px Arial, Helvetica, sans-serif';
    rows.forEach((row, i) => {
      const ry = ly + i * 15;
      ctx.fillStyle = row[0];
      ctx.fillRect(x + 8, ry + 3, 12, 3);
      ctx.fillStyle = 'rgba(255,255,255,0.8)';
      ctx.fillText(row[1], x + 24, ry + 8);
    });
    ctx.restore();
  };

  const handleExportScrollmap = async () => {
    const iframe = document.getElementById('vis') as HTMLIFrameElement | null;
    const doc = iframe?.contentDocument || iframe?.contentWindow?.document;
    if (!doc || !doc.body) {
      notifications.show({ color: 'red', title: 'Export', message: 'Scroll map is not ready yet. Please wait for it to load.' });
      return;
    }
    setExporting(true);
    handleShowHideLoader(true);
    // Declared out here so the finally block can always put the overlays back, even on a throw.
    const hidden: Array<{ el: HTMLElement; display: string }> = [];
    try {
      const target = doc.body;
      const docEl = doc.documentElement;
      // The band table spans the whole document, so the export is the whole page.
      // Size to the band table itself. scrollWidth can be wider than the mapped area (a stray
      // overflowing element), which would leave a dead strip down the side of the export.
      const bandTable = doc.getElementById('visi_vis_scrollmap') as HTMLElement | null;
      const captureWidth = (bandTable && bandTable.offsetWidth)
        ? bandTable.offsetWidth
        : Math.max(docEl.clientWidth, target.clientWidth, docEl.scrollWidth);
      const captureHeight = Math.max(docEl.scrollHeight, target.scrollHeight, docEl.clientHeight);
      try { docEl.scrollTop = 0; target.scrollTop = 0; } catch (e) { /* ignore */ }
      // Live-view furniture has no place in a static image. The ruler is position:fixed, so it
      // would be captured once at whatever spot it occupies (the export draws its own
      // full-height one). The on-screen legend, the hover readout and a selected stat's marker
      // describe where the pointer happened to be, not the page - and all of them were being
      // baked into exports, the legend over the hero. Same-origin srcDoc, so hide them for the
      // capture and put them back after.
      ['visi-sm-ruler', 'visi-sm-ruler-key', 'visi-scrollmap-widget', 'visi-sm-highlight', 'visi-sm-pick-edge']
        .forEach((id) => {
          const el = doc.getElementById(id) as HTMLElement | null;
          if (!el) { return; }
          hidden.push({ el, display: el.style.display });
          el.style.display = 'none';
        });
      try { if ((doc as any).fonts && (doc as any).fonts.ready) { await (doc as any).fonts.ready; } } catch (e) { /* ignore */ }
      // Same three caps the heatmap export uses: browsers cap one image at ~16k per side, and
      // a tall page at high DPI would otherwise build a canvas big enough to OOM the tab.
      const MAX_DIM = 16000;
      const MAX_PIXELS = 45000000;
      const measureCtx = document.createElement('canvas').getContext('2d');
      if (!measureCtx) { throw new Error('canvas context unavailable'); }
      const headerBlock = buildExportHeader(measureCtx, captureWidth);
      const HEADER_H = headerBlock.height;
      // The finished image is the page PLUS the ruler column and the header band, so every cap
      // is measured against those totals - not the page alone.
      const outW = captureWidth + EXPORT_RULER_W;
      const outH = captureHeight + HEADER_H;
      let scale = Math.min(
        3,
        MAX_DIM / outW,
        MAX_DIM / outH,
        Math.sqrt(MAX_PIXELS / (outW * outH))
      );
      if (!isFinite(scale) || scale <= 0) { scale = 1; }

      // snapdom shrinks any capture bigger than the browser's image-decode limit (16384px a side)
      // BEFORE applying the scale it is given, so passing our scale straight through shrank a
      // tall page twice - a 27,000px page came out at a third of its size. Ask for our scale
      // divided by that first shrink, so what comes back is the size we meant.
      const DECODE_MAX = 16384;
      const decode = Math.min(1, DECODE_MAX / captureWidth, DECODE_MAX / captureHeight,
        Math.sqrt((DECODE_MAX * DECODE_MAX) / (captureWidth * captureHeight)));
      const captured = await snapdom.toCanvas(target, {
        scale: scale / decode,
        dpr: 1,
        backgroundColor: '#ffffff',
        embedFonts: true,
        clip: { x: 0, y: 0, width: captureWidth, height: captureHeight },
      });

      // Everything else is drawn at the scale snapdom actually produced, whatever it had to do
      // to get there. Drawn at the requested scale while the page came back smaller, the header
      // was laid out for one width and painted into a narrower image - and lost the end of its
      // stats line.
      const drawn = captureHeight > 0 ? captured.height / captureHeight : scale;

      // Composite the context band on top of the captured page rather than injecting it into
      // the customer's DOM, so the page is never mutated to produce the export.
      const out = document.createElement('canvas');
      // The ruler sits BESIDE the page rather than over it, so nothing on the map is covered.
      const rulerPx = Math.round(EXPORT_RULER_W * drawn);
      out.width = captured.width + rulerPx;
      out.height = captured.height + Math.round(HEADER_H * drawn);
      const ctx = out.getContext('2d');
      if (!ctx) { throw new Error('canvas context unavailable'); }
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, out.width, out.height);
      drawExportHeader(ctx, headerBlock, out.width / drawn, drawn);
      ctx.drawImage(captured, 0, Math.round(HEADER_H * drawn));
      drawExportRuler(ctx, captured.width / drawn, HEADER_H, captured.height / drawn, drawn);

      const name = (selectedScrollmapName || 'scrollmap').replace(/[^\w-]+/g, '_');
      const link = document.createElement('a');
      link.download = `${name}.png`;
      link.href = out.toDataURL('image/png');
      link.click();
    } catch (e) {
      console.error('Scroll map export failed', e);
      notifications.show({ color: 'red', title: 'Export failed', message: 'Could not export the scroll map. Please try again.' });
    } finally {
      hidden.forEach(({ el, display }) => { el.style.display = display; });
      setExporting(false);
      handleShowHideLoader(false);
    }
  };

  const handleShowHideLoader = (value:any) => {
    var overlay = window.parent.parent.document.getElementById('overlay');
    if(value === true){
      overlay.innerHTML = '<div id="small_overlay" style="visibility: visible; display: block; background: none;"><h1>Page Loading...</h1><img src="/img/loading.gif" height="22" width="126" alt="Loading..."></div>';
      overlay.style.display = 'block';
      overlay.style.visibility = 'visible';
    }else{
      overlay.style.display = 'none';
      overlay.style.visibility = 'hidden';
    }
  };

  return (
    <>
      {showHelpModal && (<SelectTooltip isVisible={showHelpModal} setIsVisible={setShowHelpModal} id={helpTargetId} tooltipPosition={tooltipPosition} />)}
      {/*START ASSETS URL*/}
      <AssetsUrl
          isAssetsUrlModalOpen={isAssetsUrlModalOpen}
          setIsAssetsUrlModalOpen={setIsAssetsUrlModalOpen}
          handleAssetsUrlModalClose={handleAssetsUrlModalClose}
          assetsUrlValue={assetsUrlValue}
          setAssetsUrlValue={setAssetsUrlValue}
          pageId={pageId}
          assetsredirecturl={fetchScrollmapDetails}
      />
      {/*END ASSETS URL*/}
      <HeaderMenu HeaderMenuValue={selectedMemberWebsite} HeaderMenuOnChange={handleHeaderMenuComponentChange}/>  
      {/* No fixed height here: the nav above is 50px of its own, so a full-window wrapper
          under it always made the page taller than the window. */}
      <div>
        <Container size="xxl">
          <Card shadow="sm" padding="sm" radius="md" withBorder style={{ height: '100%' }}>
            <div style={{ display: 'flex',marginBottom: '10px' }}>
              <input id="scrollmap_created_date" value={scrollmapCreateDate} style={{ display: 'none' }} readOnly />
              <input id="get_time_selected" value={selectedTimePicker} style={{ visibility: 'hidden', position: 'absolute', left: '-9999px' }} />
              <TextInput id="from" value={selectedTimePickerFromDate} style={{ display: 'none' }} readOnly />
              <TextInput id="to" value={selectedTimePickerToDate} style={{ display: 'none' }} readOnly />
              <Group position="apart" mb="xs">
                <Text weight={500}>{selectedScrollmapName} <IconHelp ref={recordingIconRef} size="1.1rem" color="red" style={{marginBottom:-6, cursor: 'pointer'}} onClick={() => handleHelpClick(255)}/></Text>
              </Group>
              <div style={{ display: 'flex',marginLeft:"auto"}}>
                <ActionIcon
                  variant="outline"
                  size="lg"
                  title="Desktop"
                  onClick={handlePCView}
                  style={{ backgroundColor: deviceType === '0' ? '#e7fcf5' : 'transparent'}}
                >
                      <IconDeviceDesktop style={{ width: '25px', height: '30px' }} />
                </ActionIcon>
                <ActionIcon
                  variant="outline"
                  size="lg"
                  title="Tablet"
                  onClick={handleTabletView}
                  style={{ margin: '0px 10px', backgroundColor: deviceType === '2' ? '#e7fcf5' : 'transparent'}}
                >
                      <IconDeviceTablet style={{ transform: 'rotate(90deg)', width: '25px', height: '30px' }}/>
                </ActionIcon>
                <ActionIcon
                  variant="outline"
                  size="lg"
                  title="Mobile"
                  onClick={handleMobileView}
                  style={{ backgroundColor: deviceType === '1' ? '#e7fcf5' : 'transparent'}}
                >
                    <IconDeviceMobile style={{ width: '25px', height: '30px' }} />
                </ActionIcon>
               {/* <div rel="devicechange" className="test-pc-active" id="test-pc" onClick={handlePCView}></div>
                <div rel="devicechange" className="test-tablet" id="test-tablet" onClick={handleTabletView}></div>
                <div rel="devicechange" className="test-mobile" id="test-mobile" onClick={handleMobileView}></div>*/}
                <ActionIcon
                    variant="white"
                    size="lg"
                    ml={10}
                >
                  <IconClockHour4 size="1.1rem" />
                </ActionIcon>
                {/*used "reviewing_test" in the SelectedPage because the condition for reviewing_test already exists in the General Components*/}
                <SelectTimePicker SelectTimePickerValue={selectedTimePicker} SelectTimePickerOnChange={handleselectedTimePickerComponentChange} SelectTimePickerFromDateOnChange={handleselectedTimePickerFromDateChange} SelectTimePickerToDateOnChange={handleselectedTimePickerToDateChange} SelectTestStartDate={getSelectedFromDate()} SelectTestEndDate={getSelectedToDate()} SelectStartDate={getStartDate()} SelectedPage='reviewing_test'/>
                <Menu width={260} position="bottom-end" withinPortal>
                  <Menu.Target>
                    <ActionIcon
                      variant="default"
                      size="lg"
                      sx={(theme) => ({
                        backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[5] : "#fff",
                      })}
                      title="Settings"
                      ml={5}
                    >
                      <IconSettings size="1.1rem" />
                    </ActionIcon>
                  </Menu.Target>
                  <Menu.Dropdown>
                    <Menu.Item px={10} py={6} id="scrollmap_refresh_stats" onClick={handleRefreshStats}>Refresh Stats</Menu.Item>
                    <Menu.Item px={10} py={6} onClick={handleResetStatClick}>Reset Stats</Menu.Item>
                    <Menu.Item px={10} py={6} onClick={handleAssetsUrlModalOpen}>Image/Style Not Loaded</Menu.Item>
                  </Menu.Dropdown>
                </Menu> 
                {dropoff.some((band:any) => band.lost > 0) && (
                  <Button
                    leftIcon={<IconTrendingDown size="1rem" />}
                    variant={colorTheme === "light" ? "light" : "outline"}
                    color="red"
                    style={{ marginLeft: '5px' }}
                    onClick={() => setDropoffOpen(true)}
                    title="Opens a breakdown table. The map annotations are always shown; this does not recolour the map."
                  >
                    Drop-off breakdown
                  </Button>
                )}
                <Button
                  leftIcon={<IconDownload size="1rem" />}
                  variant={colorTheme === "light" ? "default" : "outline"}
                  style={{ marginLeft: '5px' }}
                  loading={exporting}
                  onClick={handleExportScrollmap}
                  title="Download scroll map as image"
                >
                  Export Image
                </Button>
                <Button variant={colorTheme === "light" ? "default" : "outline"} style={{ marginLeft: '5px' }} onClick={handleBackToInsightsClick}>Back to Insights</Button>
              </div>
            </div>
            <div style={{ display: 'flex', gap: '4px' }}>
              <Text weight={500}>Page URL: </Text>
              <Link to={pageUrl} target="_blank" style={{ textDecoration: 'none', color: colorTheme === "light" ? "black" : "white" }}>{pageUrl}</Link>
            </div>
            {scrollStats && (
              <div style={{ display: 'flex', gap: '20px', alignItems: 'center', flexWrap: 'wrap', marginTop: '4px' }}>
                <Text size="sm"><b>Visitors:</b>{' '}
                  <button type="button" style={statButton} title="Jump to the top of the page"
                    onClick={() => goToDepth(0, `${Number(scrollStats.totalSessions).toLocaleString()} visitors started here`)}>
                    {Number(scrollStats.totalSessions).toLocaleString()}
                  </button>
                </Text>
                {/* null means nobody scrolled, which is not the same as scrolling 0%. */}
                <Text size="sm"><b>Avg scroll depth:</b>{' '}
                  {scrollStats.avgScrollDepth === null || scrollStats.avgScrollDepth === undefined
                    ? <Text span size="sm" color="dimmed" title="No visitor in this range scrolled">— nobody scrolled</Text>
                    : <button type="button" style={statButton} title="Jump to the average scroll depth"
                        onClick={() => goToDepth(scrollStats.avgScrollDepth, `Average scroll depth — ${scrollStats.avgScrollDepth}% down the page`)}>
                        {scrollStats.avgScrollDepth}% down the page
                      </button>}
                </Text>
                <Text size="sm"><b>Reached bottom:</b>{' '}
                  {scrollStats.reachedBottomPercent === null || scrollStats.reachedBottomPercent === undefined
                    ? <Text span size="sm" color="dimmed">—</Text>
                    : <button type="button" style={statButton} title="Jump to the bottom of the page"
                        onClick={() => goToDepth(100, `${bottomLabel()} reached here`)}>
                        {bottomLabel()}
                      </button>}
                </Text>
                <Text size="sm"><b>Page height:</b>{' '}
                  {scrollStats.pageHeightPx
                    ? <>{Number(scrollStats.pageHeightPx).toLocaleString()}px</>
                    : <Text span size="sm" color="dimmed">&mdash;</Text>}
                </Text>
                {/* Deepest point ANY visitor reached - the count is shown so one outlier cannot be misread. */}
                <Text size="sm"><b>Deepest reached:</b>{' '}
                  {scrollStats.deepestPercent === null || scrollStats.deepestPercent === undefined
                    ? <Text span size="sm" color="dimmed">&mdash;</Text>
                    : <button type="button" style={statButton} title="Jump to the deepest point any visitor reached"
                        onClick={() => goToDepth(scrollStats.deepestPercent, `Deepest point reached — ${scrollStats.deepestPercent}% down the page`)}>
                        {scrollStats.deepestPercent}% down the page ({Number(scrollStats.deepestVisitors ?? 0).toLocaleString()}{' '}
                        {scrollStats.deepestVisitors === 1 ? 'visitor' : 'visitors'})
                      </button>}
                </Text>
                {/* Never null-safe: older sessions predate scroll attribution and cannot be classified. */}
                <Text size="sm"><b>Never scrolled:</b>{' '}
                  {scrollStats.neverScrolledPercent === null || scrollStats.neverScrolledPercent === undefined
                    ? <Text span size="sm" color="dimmed" title="Recorded before scroll attribution shipped">not available yet</Text>
                    : <>{scrollStats.neverScrolledPercent}% of visitors</>}
                </Text>
                {dropoffZones.length > 0 && (
                  <Text size="sm"><b>Drop-offs:</b>{' '}
                    {dropoffZones.map((band: any, i: number) => (
                      <span key={band.fromPercent}>
                        {i > 0 ? ' \u00b7 ' : ''}
                        <button type="button" style={statButton}
                          title={`Jump to the ${band.rank ? '#' + band.rank + ' ' : ''}drop-off zone`}
                          onClick={() => goToDepth((band.fromPercent + band.toPercent) / 2,
                            `${band.rank ? '#' + band.rank + ' ' : ''}drop-off \u2014 ${band.fromPercent}\u2013${band.toPercent}% down the page`)}>
                          {band.rank ? `#${band.rank} ` : ''}{band.fromPercent}–{band.toPercent}%
                        </button>
                      </span>
                    ))}
                  </Text>
                )}
                {scrollStats.lowSample && (
                  <Text size="sm" color="orange" weight={600}>Fewer than 100 visitors — treat this map as indicative only</Text>
                )}
              </div>
            )}
            <div className="test-wrapper flexed" style={{ width: '100%', height: '100%' }}>
              <Helmet>
                <link rel="stylesheet" type="text/css" href="/css/visiopt-visual.css"/>
                {loadResourceLoaded === 1 ?                  
                <script type="text/javascript">
                {`
                  var jQcustom = jQuery.noConflict();
                  function adjustIframeSize() {
                    var frame = document.getElementById('vis');
                    if (!frame) { return; }
                    // Size the preview to the room actually left under the header. This used to
                    // subtract the height of a '.header-element' that exists nowhere, so it fell
                    // back to a 200px guess - shorter than the real header - and the page grew a
                    // scrollbar of its own beside the preview's.
                    var scrolled = window.pageYOffset || document.documentElement.scrollTop || 0;
                    var startsAt = frame.getBoundingClientRect().top + scrolled;
                    var room = Math.max(300, jQcustom(window).height() - startsAt);
                    // 'important' so it also beats the fixed 680px / 1000px heights the phone and
                    // tablet frames carry in the stylesheet.
                    frame.style.setProperty('height', room + 'px', 'important');
                    // Whatever still pushes the page past the window (frame borders, card padding)
                    // comes off the preview as well, so only the preview scrolls.
                    var overflow = document.documentElement.scrollHeight - jQcustom(window).height();
                    if (overflow > 0 && room - overflow >= 300) {
                      frame.style.setProperty('height', (room - overflow) + 'px', 'important');
                    }
                    jQcustom('#vis').css({
                      "width": jQcustom(window).width() + "px !important"
                    });
                  }

                  adjustIframeSize();

                  jQcustom(window).resize(function() {
                    adjustIframeSize();
                  });

                `}
                </script>
                : ''}
              </Helmet>
              <link rel="stylesheet" id="test_added_font" type="text/css" />
              <style type="text/css" id="test_added_css"></style>
              <iframe
                className={deviceFrameClass && colorTheme !== 'light' ? deviceFrameClass + ' visi-frame-dark' : deviceFrameClass}
                style={{
                  height: '100vh',
                  border: 'none',
                  userSelect: 'none',
                  display: 'block',
                  marginLeft: deviceType === '0' ? '-8px' : undefined
                }}
                id="vis"
                title="Scrollmap Iframe"
                srcDoc={iframeContent}
              />
            </div>
          </Card>
        </Container>
      </div>
      <div id="overlay" style={{ visibility: "hidden", display: "none", backgroundImage: "none", backgroundColor: 'rgba(255, 255, 255, 0.7)', zIndex: '9999' }} />
      <Modal opened={dropoffOpen} onClose={() => setDropoffOpen(false)} title={<Text weight={600}>Drop-off by page depth</Text>} size="lg" centered>
        <Text size="sm" mb="sm" color="dimmed">
          Each band is 5% down the page. Loss is the visitors who entered the band and never carried on past it.
          Measured against all <b>{Number(scrollStats?.totalSessions ?? 0).toLocaleString()} {Number(scrollStats?.totalSessions ?? 0) === 1 ? 'visitor' : 'visitors'}</b> — a visitor who never scrolled counts at the bottom of their first screen.
          On the map a zone is numbered only when it lost more than one visitor more than the next zone. Bars use the same scale as the % column.
        </Text>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ borderCollapse: 'collapse', fontSize: '14px', width: '100%' }}>
            <thead>
              <tr>
                {['Page depth', 'Entered', 'Lost here', '% of visitors', ''].map((head) => (
                  <th key={head} style={{ textAlign: 'left', padding: '8px 14px', borderBottom: `2px solid ${colorTheme === 'light' ? '#dee2e6' : '#495057'}`, fontWeight: 600 }}>{head}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {dropoff.map((band:any) => (
                <tr key={band.fromPercent}>
                  <td style={{ padding: '8px 14px', borderBottom: `1px solid ${colorTheme === 'light' ? '#f1f3f5' : '#343a40'}`, whiteSpace: 'nowrap' }}>{band.fromPercent}–{band.toPercent}% down</td>
                  <td style={{ padding: '8px 14px', borderBottom: `1px solid ${colorTheme === 'light' ? '#f1f3f5' : '#343a40'}` }}>{Number(band.entered).toLocaleString()}</td>
                  <td style={{ padding: '8px 14px', borderBottom: `1px solid ${colorTheme === 'light' ? '#f1f3f5' : '#343a40'}`, fontWeight: 700 }}>{Number(band.lost).toLocaleString()}</td>
                  <td style={{ padding: '8px 14px', borderBottom: `1px solid ${colorTheme === 'light' ? '#f1f3f5' : '#343a40'}` }}>{band.lostPercent}%</td>
                  <td style={{ padding: '8px 14px', borderBottom: `1px solid ${colorTheme === 'light' ? '#f1f3f5' : '#343a40'}`, width: '40%' }}>
                    <div style={{ background: colorTheme === 'light' ? '#f1f3f5' : '#343a40', borderRadius: '3px', height: '10px', width: '100%' }}>
                      <div style={{ background: '#d62d2d', borderRadius: '3px', height: '10px', width: `${Math.min(100, band.lostPercent)}%`, minWidth: band.lost > 0 ? '2px' : 0 }} />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Modal>
    </>
  );
}